// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"332":"detail","962":"home"}[chunkId] + "." + {"332":"27b95986","962":"7c4c93f2"}[chunkId] + ".js";
};